import type { PlanInfo } from '../../types/home.types';
import styles from './PlanUpgradeCard.module.css';
import { Star } from '@mui/icons-material';
import { useAuth } from '@practium/features/auth';
import { useGetPlanSummary } from '@practium/features/api';
import { UserRole } from '@practium/shared';
import { Button } from '@practium/ui';

interface PlanUpgradeCardProps {
	planInfo: PlanInfo;
	onUpgradeClick?: () => void;
}

export const PlanUpgradeCard = ({ planInfo, onUpgradeClick }: PlanUpgradeCardProps) => {
	const auth = useAuth();
	const { data: summary } = useGetPlanSummary(auth.user?.role !== UserRole.Admin);
	const canUpgrade = auth.user?.role !== UserRole.Admin && summary?.canUpgrade === true;
	const currentPlanName = summary?.plan?.name ?? planInfo.name;
	const expirationDate = summary?.expiresIn
		? new Date(summary.expiresIn).toLocaleDateString('pt-BR')
		: planInfo.expirationDate;
	const upgradeMessage =
		summary?.canUpgrade && summary?.upgradePlanName
			? `Aproveite mais recursos com o plano ${summary.upgradePlanName}.`
			: planInfo.upgradeMessage;

	return (
		<div className={styles.card}>
			<div className={styles.content}>
				<div className={styles.topRow}>
					<div className={styles.planInfo}>
						<span className={styles.currentPlanLabel}>Meu Plano Atual</span>
						<div className={styles.planNameWrapper}>
							<span className={styles.planName}>{currentPlanName}</span>
							<Star className={styles.icon} />
						</div>
					</div>

					{canUpgrade ? (
						<Button variant="secondary" className={styles.upgradeButton} onClick={onUpgradeClick}>
							Fazer Upgrade
						</Button>
					) : null}
				</div>

				<div className={styles.bottomRow}>
					<p className={styles.upgradeMessage}>{upgradeMessage}</p>
					<span className={styles.expirationDate}>{expirationDate}</span>
				</div>
			</div>
		</div>
	);
};
